module.exports = __webpack_public_path__ + "img/integridad.204d5958.png";